export default __webpack_public_path__ + "static/media/menu-black.4a8b8070.svg";